import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ItemVerificar } from "src/app/models/ItemVerificar";

@Injectable()
export class ItensVerificarService {
  private itensVerificar: ItemVerificar[] = this.carregarItens();
  private itens$ = new BehaviorSubject<ItemVerificar[]>(this.itens);

  constructor() {}

  public get itens(): ItemVerificar[] {
    if (!this.itensVerificar) {
      this.itensVerificar = this.carregarItens();
    }

    return this.itensVerificar;
  }

  public set itens(value: ItemVerificar[]) {
    localStorage.setItem("itens-verificar", JSON.stringify(value));
    this.itensVerificar = value;
  }

  updateItens() {
    this.itens$.next(this.itens);
  }

  getItens(): Observable<ItemVerificar[]> {
    return this.itens$.asObservable();
  }

  private carregarItens(): ItemVerificar[] {
    return JSON.parse(localStorage.getItem("itens-verificar"));
  }
}
